export default __webpack_public_path__ + "fa1176dd3085ffd8ec87360e7f40e397.svg";